/** @format */

import {Chart} from 'components/charts/multiline-chart/model/charts';

import {PointName} from 'components/charts/multiline-chart/model/common';

import {ValueKey} from 'features/forecast/types';
import {calcMetricForecast} from 'features/mediaplan-progress/helpers/calcMetricForecast';

import {CHARTS_PREDICATES} from '../../constants/predicates';
import {getPrimaryValuesList} from './getPrimaryValuesList';
import {injectForecastToChartData} from './injectForecastToChartData';
import {ChartIds} from '../../models/chartIds';

interface Options {
  chart: Chart<ChartIds>;
  simpleChartsWithForecast: Chart<ChartIds>[];
  forecastDays: ValueKey[];
  normalPoints: PointName[];
}

const addForecastToComplexChart = ({
  chart,
  simpleChartsWithForecast,
  forecastDays,
  normalPoints,
}: Options): Chart<ChartIds> => {
  const predicate = CHARTS_PREDICATES[chart.chartId];

  if (!predicate?.forecastPredicate) {
    return chart;
  }

  const chartA = simpleChartsWithForecast.find(item => item.chartId === predicate.forecastDataA);
  const chartB = simpleChartsWithForecast.find(item => item.chartId === predicate.forecastDataB);

  if (!chartA || !chartB) {
    return chart;
  }

  const {primary} = calcMetricForecast({
    kind: 'ratio',
    a: getPrimaryValuesList(chartA.chartsData, normalPoints),
    b: getPrimaryValuesList(chartB.chartsData, normalPoints),
    forecastRange: predicate.forecastPredicate,
    forecastDays,
  });

  const newChartData = injectForecastToChartData({
    original: chart.chartsData,
    primaryForecast: primary,
    secondaryForecast: null,
  });

  return {
    ...chart,
    chartsData: newChartData,
  };
};

export {addForecastToComplexChart};
